define('lib/view/mixin/IntlPhone',['require','Config'],function (require) {

    var Config = require('Config');

    return {

        showIntlPhone: function (visibleInputSelector, options ) {
            var _this = this;

            if(!options || !_.isObject(options)){
                options = {};
            }

            clearTimeout(window.intlPhoneTimer);
            window.intlPhoneTimer = setTimeout(function () {
                if (visibleInputSelector && visibleInputSelector.closest(document).length) {
                    _this._showIntlPhone(visibleInputSelector, options);
                } else{
                    console.log('unkown phone field');
                }
            }, 500);
        },

        _getReqiredFields : function(){;
            if(!this.requiredFields){
                this.requiredFields =  Config.getInstance().getOption('require_fields');
                if (!this.requiredFields) {
                    this.requiredFields =  Config.getInstance().getOption('client_require_fields');
                }
            }
            return this.requiredFields;
        },

        _isFieldRequired : function(field){
            var requiredFields = this._getReqiredFields();
            if(!requiredFields){
                return false;
            }
            return requiredFields && field && requiredFields.indexOf(field) >= 0;
        },

        _showIntlPhone: function (visibleInputSelector, options ) {
            if(jQuery(visibleInputSelector).length){

                this._preparePhone(visibleInputSelector, options);

                this._initGenerator();

                var $hiddenInp = jQuery(visibleInputSelector);
                var $visibleInp = $hiddenInp.clone();

                $visibleInp.insertAfter($hiddenInp);
                $visibleInp.attr('id', idGen.getId()).attr('name', idGen.getId());

                $hiddenInp.css({
                    'width' : '0px',
                    'height' : '0px',
                    'padding' : '0px',
                    'margin' : '0px',
                    'position' : 'absolute',
                    'border' : 'none',
                });

                this._initIntl($visibleInp, $hiddenInp, options);

            } else{
                console.warn('Unknown input');
            }
        },

        _initIntl: function (visibleInputSelector, hiddenInputSelector, options ) {
            if(jQuery(visibleInputSelector).length){
                var id = jQuery(visibleInputSelector).attr('id');

                if(!id){
                    this._initGenerator();
                    id = window.idGen.getId();
                    jQuery(visibleInputSelector).attr('id', id);
                }

                var idHidden = jQuery(hiddenInputSelector).attr('id');
                id = '#'+ id;
                idHidden = idHidden?'#'+ idHidden:null;

                var companyCountry = null;
                var companyData = Config.getInstance().getOption('company');
                if(!companyData){
                    companyData = Config.getInstance().getOption('company_data');
                }
                if(companyData){
                    companyCountry = companyData.country_id;
                }
                var initialCountry = Config.getInstance().getOption('country_phone_initial');

                if(!initialCountry && companyCountry){
                    initialCountry = String(companyCountry).toLowerCase();
                }

                this.phoneInput = new IntlInitializer(id, idHidden, jQuery.extend({
                    initialCountry : initialCountry,
                    hiddenInput: idHidden,
                    showError : false,
                    showErrorBorder : false,
                    nationalMode: true,
                    required: this._isFieldRequired('phone'),
                    errorTemplate: "<div class=\"errors\"> <div class=\"invalid-feedback\">{{error}}</div> </div>"
                }, options));
            } else{
                console.warn('Unknown input');
            }
        },

        _preparePhone : function(visibleInputSelector, options){
            var $inp = jQuery(visibleInputSelector);

            if($inp && $inp.length){
                var number = String($inp.val()).trim();

                if(number){
                    var fChar = number.charAt(0);

                    if(fChar !== '+' && fChar !== '0'){
                        number = '+' + number;
                        $inp.val(number).trigger('change');
                    }
                }
            }
        },

        _initGenerator : function () {
            if(!window.Generator) {
                window.Generator = function () {
                };
                window.Generator.prototype.rand = Math.floor(Math.random() * 26) + Date.now();
                window.Generator.prototype.getId = function () {
                    this.rand++;
                    return 'p' + this.rand;
                };
                window.idGen = new Generator();
            }
        },

    };

});

